/** Intrinsic dimensions for layout-stable image rendering (CLS) */
export const LOGO_BRAND_WIDTH = 410;
export const LOGO_BRAND_HEIGHT = 308;

/** Typical brand logo slot in marquees (width × height) */
export const BRAND_LOGO_SLOT_WIDTH = 120;
export const BRAND_LOGO_SLOT_HEIGHT = 40;
